// Model commands creator - for sending to server

import { ILinkObject } from "./common/ah.mb.common.node-object";
import { LinkValidator, LinkValidationResult } from "./ah.mb.link-validator";
import { CommodityAndUnitsRec } from "./ah.mb.commodity-and-units-rec";
export class ModelUtils {

    private linkValidation: LinkValidator;

    /**
     * Ctor
     */
    constructor(linkValidator: LinkValidator) {
        this.linkValidation = linkValidator;
    }

    /**
     * Builds a shadow node name
     */
    buildShadowName = (nodeName: string, nodePath: string): string => {

        // result is [Sector] NodeName
        var delim = nodePath.lastIndexOf("\\");
        var sector = nodePath.substring(delim + 1);
        return `[${sector}] ${nodeName}`;
    };

    /**
 * Builds a renamed node name
 */
    buildRenamedNodePathAndName = (originalPathAndName: string, newName: string): string => {
        var delim = originalPathAndName.lastIndexOf("\\");
        var sector = originalPathAndName.substring(0, delim + 1);
        return sector + newName;
    };

    /**
 * Extracts a node path
 */
    extractPath = (nodePath: string): string => {
        // result is [Sector] NodeName
        var delim = nodePath.lastIndexOf("\\");
        var sector = nodePath.substring(0, delim);
        return sector;
    };

    /**
* Extracts a path stack
*/
    static extractPathStackFromPathAndName = (nodePath: string, includeName?: boolean): string[] => {
        // result is [Sector] NodeName
        var result = nodePath.split("\\");
        // Don't return first, which is ""

        if (includeName)
            return result.slice(1, result.length);
        else
            return result.slice(1, result.length - 1);
    };

    /**
* Gets a node name
*/
    static extractName = (nodePath: string): string => {
        // result is [Sector] NodeName
        var delim = nodePath.lastIndexOf("\\");
        var sector = nodePath.substring(delim + 1);
        return sector;
    };

    /**
 * Validates a node link
 */
    canLink = (srcNode: any,
        destNode: any,
        srcOutputs: ILinkObject[],
        destInputs: ILinkObject[],
        existingSrcCommodities: CommodityAndUnitsRec[],
        existingDestCommodities: CommodityAndUnitsRec[],
        commodityRec): LinkValidationResult => {

        return this.linkValidation.validateLink(srcNode,
            destNode,
            srcOutputs,
            destInputs,
            existingSrcCommodities,
            existingDestCommodities,
            commodityRec);

    };

    static buildPathAndNameFromSegments(segments: string[]): string {
        return `\\${segments.join("\\")}`;
    }

    /**
 * Node type link validation
 */
    canLinkNodeTypes = (srcNodeType: string,
        destNodeType: string,
        existingSrcCommodities,
        existingDestCommodities,
        newCommodity,
        srcOutputs: ILinkObject[],
        destInputs: ILinkObject[]): LinkValidationResult => {
        return this.linkValidation
            .validateLinkByNodeTypes(srcNodeType,
                destNodeType,
                existingSrcCommodities,
                existingDestCommodities,
                newCommodity,
                srcOutputs,
                destInputs);
    };

    /**
 * Checks if node rename ok
 */
    canRename = (nodeType: string, isShadow: boolean): LinkValidationResult => {
        if (isShadow)
            return {
                ok: false,
                msg: "Cannot rename a shadow"
            };

        if (nodeType === "Root")
            return {
                ok: false,
                msg: "Cannot rename the root node"
            };

        return {
            ok: true,
            msg: ""
        };
    };

    static canRepositionNodeResult: LinkValidationResult = { ok: true, msg: "" };

    /**
 * Checks if node reposition is allowed
 */
    canRepositionNode = (node: any): LinkValidationResult => ModelUtils.canRepositionNodeResult;

    /**
 * Validates a node deletion
 */

    canDeleteNode = (nodeType: string, isShadow: boolean): LinkValidationResult => {
        if (isShadow) {
            return {
                ok: false,
                msg:
                    "Cannot delete a shadow node"
            };
        }

        if (nodeType === "Root") {
            return {
                ok: false,
                msg:
                    "Cannot delete a root node"
            };
        }

        return {
            ok: true,
            msg: ""
        };
    };


    /**
 * Checks child node type is allowed
 */
    eligibleChildNodeType = (nodeType: string): string => {
        switch (nodeType) {
            case "Root":
                {
                    return "Model";
                }
            case "Model":
                {
                    return "Sector";
                }
            case "Sector":
                {
                    return "Sector";
                }
            case "ReportFolder":
                {
                    return "ReportFolder,Report";
                }
            case "DirectoryFolder":
                {
                    return "DirectoryFolder,DirectoryModel";
                }
            case "RecordsExportDefinition":
                {
                    return "RecordsExportDefinition";
                }

            default:
                {
                    return "";
                }
        }
    };

    /**
    * Gets common commodities in a list
    */
    getCommodityUnion = (list1: CommodityAndUnitsRec[],
        list2: CommodityAndUnitsRec[],
        srcNodeType: string,
        destNodeType: string): CommodityAndUnitsRec[] => {

        return this.linkValidation.getAvailableCommodities(list1, list2, srcNodeType, destNodeType);
    };

    static buildScenarioModelId(parentModelId, scenarioName: string): string {
        return `${parentModelId}:${scenarioName}`;

    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.ui.model-utils.ts